import styled from 'styled-components'
import React from 'react';

import Icon from '../reusable/Icon'


const Next = ({ active, toggleActive, color }) => {
  
  return(
    <Button color={color} aria-label="arrRight" onClick={()=>toggleActive(active === 3 ? 0 : active+1)}>
      <Icon icon="arrRight" width={25} height={12} margin="0px 16px 0px 0px" />
    </Button>
  )
}

export default Next


const Button = styled.button(props => ({
  color:props.color,
  background:"transparent",
  display:"flex",
  cursor:"pointer",
  whiteSpace:"no-break",
  alignItems:"center",
  transition:"0.2s ease-in-out",
  border:"none",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  outline:"none",
  paddingRight:16,
  paddingLeft:16,
}));
